/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".move-entries-dialog-container{width:350px}move-entries-dialog folders-tree{border:1px solid #eff1f2;border-radius:3px}move-entries-dialog .mat-dialog-actions{margin-top:15px}"];
export { styles as styles };
